import { Component, signal } from '@angular/core';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { User } from '../../models/User';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { PremiumOfferService } from '../../services/premium-offer.service';
import { StorageService } from '../../services/storage.service';

@Component({
  selector: 'app-onboarding2',
  standalone: true,
  imports: [TranslateModule, LottieComponent],
  templateUrl: './onboarding2.component.html',
  styleUrl: './onboarding2.component.scss',
})
export class Onboarding2Component {
  user?: User;
  avatars: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34];
  selectedAvatar?: number;
  isOnboarding = signal(true);

  private avatarAnimationOptions = new Map<number, AnimationOptions>();

  constructor(
    private router: Router,
    private authService: AuthService,
    private premiumOfferService: PremiumOfferService,
    private storageService: StorageService,
  ) {}

  async ngOnInit() {
    this.isOnboarding.set(window.location.pathname.includes('onboarding'));
    this.user = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());

    if (this.user?.avatar_id !== undefined) {
      this.selectedAvatar = parseInt(this.user.avatar_id);
    }
  }

  select(avatar: number) {
    this.selectedAvatar = avatar;
  }

  async next() {
    if (this.selectedAvatar === undefined) {
      return;
    }

    const actualUser = await firstValueFrom(this.authService.getUserInfoOrRefreshIfNeeded());
    const update = await firstValueFrom(this.authService.updateMyUser(actualUser.id ?? '', undefined, this.selectedAvatar, undefined));
    const user = await firstValueFrom(this.authService.forceUpdateUser());

    if (`${this.selectedAvatar}` === update.avatar_id) {
      if (this.isOnboarding()) {
        this.router.navigate(['/onboarding/3']);
      } else {
        this.router.navigate(['/settings']);
      }
    }
  }

  shouldDisplayFourthStep(): boolean {
    return !this.storageService.isAnonymous() && this.premiumOfferService.canSeePremiumOffers(this.user);
  }

  avatarAnimationOptionsForAvatar(avatar: number): AnimationOptions {
    // Check if we already have animation options for this avatar
    if (this.avatarAnimationOptions.has(avatar)) {
      return this.avatarAnimationOptions.get(avatar)!;
    }

    const animationPath = `assets/lottie/avatars/${avatar}.json`;
    const options: AnimationOptions = {
      path: animationPath,
      autoplay: false,
      loop: true,
    };

    this.avatarAnimationOptions.set(avatar, options);

    return options;
  }

  onError(error: any) {
    console.error('Lottie error: ', error);
  }

  getBackgroundColorForAvatar(avatar: number): string {
    const array = ['#5a36b2', '#007eff', '#3abcd8', '#ec407a', '#0fc461', '#ee8b60', '#f4b60b'];

    return array[avatar % array.length];
  }
}
